import { AfterViewInit, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DrawerComponent } from '../../layout/kt/components';
import { CompanyModel } from 'src/app/models/company.model';
import { CompaniesService } from 'src/app/services/company.service';
import { CompanyFilesService } from 'src/app/services/company-files.service';
import { GlobalStoreService } from 'src/app/services/global-store.service';
import { ToastService } from 'src/app/services/toast.service';
import { SharedImports } from 'src/app/shared-imports';
@Component({
	selector: 'app-select-files-drawer',
	templateUrl: './select-files-drawer.component.html',
	styleUrls: ['./select-files-drawer.component.scss'],
	imports: [SharedImports],
})
export class SelectFilesDrawerComponent implements OnInit, AfterViewInit, OnDestroy {
	files$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	list_size$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	totalCount: number;
	tableInfo = {
		pageSize: 12,
		pageIndex: 1,
		pageOptions: [12, 24, 48],
		ini: 0,
		end: 0,
	};
	activeCompany: CompanyModel;
	private _subscriptions: Subscription[] = [];
	private params: any = {
		page: 1,
		per_page: 10,
	};

	activeOption: any = null;
	storeLogoToStore: any = false;
	fileToCompany: any = false;
	coverFileToStore: any = false;
	logoFileToTerminal: any = false;
	playListTerminal: any = false;
	coverFileToTerminal: any = false;

	private mutationObserver: MutationObserver | null = null;

	private toastService = inject(ToastService);
	private companiesService = inject(CompaniesService);
	private companyFilesService = inject(CompanyFilesService);
	private globalStoreService = inject(GlobalStoreService);

	constructor() {
		this._subscriptions.push(
			this.companiesService.company$.subscribe({
				next: (res) => {
					if (res && res?.uuid) {
						this.activeCompany = res;
						this.loadCompanyFiles();
					}
				},
				error: (err) => {},
				complete: () => {},
			})
		);
		this._subscriptions.push(
			this.globalStoreService.updateListFiles$.subscribe((res) => {
				if (res) {
					this.loadCompanyFiles();
				}
			})
		);
		this._subscriptions.push(
			this.globalStoreService.filesToOption$.subscribe((option) => {
				if (option) {
					this.activeOption = { ...option };
				}
			})
		);
		this._subscriptions.push(
			this.globalStoreService.filesToCompany$.subscribe((file) => {
				if (file) {
					this.fileToCompany = true;
				}
			})
		);
		this._subscriptions.push(
			this.globalStoreService.logoFileToStore$.subscribe((file) => {
				if (file) {
					this.storeLogoToStore = true;
				}
			})
		);
		this._subscriptions.push(
			this.globalStoreService.coverFileToStore$.subscribe((file) => {
				if (file) {
					this.coverFileToStore = true;
				}
			})
		);
		this._subscriptions.push(
			this.globalStoreService.editingLogoTerminal$.subscribe((file) => {
				this.logoFileToTerminal = file;
			})
		);
		this._subscriptions.push(
			this.globalStoreService.filesToTerminalPlaylist$.subscribe((playlist) => {
				if (playlist) {
					this.playListTerminal = true;
				}
			})
		);
		this._subscriptions.push(
			this.globalStoreService.editingCoverTerminal$.subscribe((file) => {
				this.coverFileToTerminal = file;
			})
		);
	}

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		if (this.mutationObserver) {
			this.mutationObserver.disconnect();
			this.mutationObserver = null;
		}

		this.mutationObserver = new MutationObserver(() => {
			const drawer = DrawerComponent.getInstance('kt_select_files');
			if (drawer) {
				drawer.on('kt.drawer.hide', () => {
					this.onClose();
				});
				this.mutationObserver?.disconnect();
				this.mutationObserver = null;
			}
		});

		this.mutationObserver.observe(document.body, {
			childList: true,
			subtree: true,
		});
	}

	loadCompanyFiles() {
		this.params.page = this.tableInfo.pageIndex;
		this.params.per_page = this.tableInfo.pageSize;
		this.companyFilesService.getManyCompanyFiles(this.activeCompany.uuid, this.params).subscribe(
			(res) => {
				this.tableInfo.ini = (res.page - 1) * this.tableInfo.pageSize + 1;
				this.tableInfo.end = this.tableInfo.ini + res.count - 1;
				this.files$.next(res.data.length > 0 ? res.data : null);
				this.totalCount = res.total;
				this.list_size$.next(res.total);
			},
			(err) => {
				this.toastService.error('toast_error_company_files', 'Error');
			}
		);
	}

	onPager(event: any) {
		this.tableInfo.pageIndex = event;
		this.loadCompanyFiles();
	}

	onPageSizeChange(event: any) {
		this.tableInfo.pageSize = event;
		this.tableInfo.pageIndex = 1;
		this.loadCompanyFiles();
	}

	selectFile(file: any) {
		if (this.playListTerminal) {
			const playlist = [...this.globalStoreService.filesToTerminalPlaylist$.value];
			playlist.push(file);
			this.globalStoreService.filesToTerminalPlaylist$.next(playlist);
		}
		if (this.logoFileToTerminal) {
			this.globalStoreService.logoFileToTerminal$.next(file);
			this.logoFileToTerminal = false;
		}
		if (this.storeLogoToStore) {
			this.globalStoreService.logoFileToStore$.next(file);
			this.storeLogoToStore = false;
		}

		if (this.coverFileToStore) {
			this.globalStoreService.coverFileToStore$.next(file);
			this.coverFileToStore = false;
		}

		if (this.fileToCompany) {
			this.globalStoreService.filesToCompany$.next(file);
			this.fileToCompany = false;
		}

		if (this.coverFileToTerminal) {
			this.globalStoreService.coverFileToTerminal$.next(file);
			this.coverFileToTerminal = false;
		}

		if (this.activeOption) {
			this.activeOption.files = !this.activeOption.files ? [] : this.activeOption.files;
			this.activeOption.files.push({
				file: {
					uuid: file.uuid,
					name: file.name,
					path: file.path,
				},
			});
			this.globalStoreService.filesToOption$.next(this.activeOption);
		}
		this.toastService.info('toast_info_file_selected', 'Info');
	}

	onClose(): void {
		this.activeOption = null;
		this.storeLogoToStore = false;
		this.fileToCompany = false;
		this.coverFileToStore = false;
		this.logoFileToTerminal = false;
		this.playListTerminal = false;
		this.coverFileToTerminal = false;
	}

	ngOnDestroy(): void {
		this._subscriptions.forEach((sub) => sub.unsubscribe());
		this.onClose();

		if (this.mutationObserver) {
			this.mutationObserver.disconnect();
			this.mutationObserver = null;
		}
	}
}
